/**
 * Integrations Page
 *
 * API key and webhook management for programmatic access.
 */

import React from 'react';
import { IntegrationsPage as IntegrationsPageComponent } from '../integrations';

export default function IntegrationsPage() {
  return <IntegrationsPageComponent />;
}
